<template>
    <div id="app" :class="[oracle.isEN() ? 'dir' : 'dirFa']" data-app>
        <div v-if="loaded">
            <router-view :class="[oracle.isEN() ? 'dir' : 'dirFa']" name="header"/>
            <main>
                <transition name="fade" mode="out-in">
                    <router-view :class="[oracle.isEN() ? 'dir' : 'dirFa']"/>
                </transition>
            </main>
            <router-view :class="[oracle.isEN() ? 'dir' : 'dirFa']" name="footer"></router-view>
        </div>
    </div>
</template>
<script>
    import oracle from "./utils/oracle";

    export default {
        data() {
            return {
                oracle: oracle,
                loaded: true
            }
        }, watch: {
            '$route': function (to, from) {
                if (to != null && !oracle.isLoggedIn() && to.meta != null && to.meta.authorize != null && to.meta.authorize) {
                    this.$router.push('/register')
                }
            }
        }, mounted() {
            oracle.receive(oracle.REFRESH, () => {
                this.loaded = false
                setTimeout(() => {
                    this.loaded = true
                }, 100)
            })
        },
        beforeCreate() {
            if (oracle.isMobile()
                && (!window.location.href.toString().includes('/accounts')
                    && !window.location.href.toString().includes('/reservations'))) {
                window.location.href = 'https://pwa.visternet.com/login'
            } else {
                if (this.$router.currentRoute != null && this.$router.currentRoute.meta != null) {
                    if (this.$router.currentRoute.meta.authorize != null && this.$router.currentRoute.meta.authorize) {
                        if (!oracle.isLoggedIn()) {
                            if (this.$router.currentRoute.meta.authenticate != null && this.$router.currentRoute.meta.authenticate) {
                                this.$router.push('/accounts/login')
                            } else {
                                this.$router.push('/register')
                            }
                        }
                    } else if (oracle.isLoggedIn()) {
                        if (window.location.href.toString().includes('/register')) {
                            this.$router.push('/profile')
                        }
                    }
                }
            }
        }
    };
</script>
<style>

    @font-face {
        font-family: Shabnam;
        src: url('~@/assets/fonts/Shabnam-FD.eot');
        src: url('~@/assets/fonts/Shabnam-FD.eot?#iefix') format('embedded-opentype'),
        url('~@/assets/fonts/Shabnam-FD.woff2') format('woff2'),
        url('~@/assets/fonts/Shabnam-FD.woff') format('woff'),
        url('~@/assets/fonts/Shabnam-FD.ttf') format('truetype');
        font-weight: normal;
    }

    @font-face {
        font-family: Shabnam;
        src: url('~@/assets/fonts/Shabnam-Bold-FD.eot');
        src: url('~@/assets/fonts/Shabnam-Bold-FD.eot?#iefix') format('embedded-opentype'),
        url('~@/assets/fonts/Shabnam-Bold-FD.woff2') format('woff2'),
        url('~@/assets/fonts/Shabnam-Bold-FD.woff') format('woff'),
        url('~@/assets/fonts/Shabnam-Bold-FD.ttf') format('truetype');
        font-weight: bold;
    }

    @font-face {
        font-family: Shabnam;
        src: url('~@/assets/fonts/Shabnam-Thin-FD.eot');
        src: url('~@/assets/fonts/Shabnam-Thin-FD.eot?#iefix') format('embedded-opentype'),
        url('~@/assets/fonts/Shabnam-Thin-FD.woff2') format('woff2'),
        url('~@/assets/fonts/Shabnam-Thin-FD.woff') format('woff'),
        url('~@/assets/fonts/Shabnam-Thin-FD.ttf') format('truetype');
        font-weight: 100;
    }

    @font-face {
        font-family: Shabnam;
        src: url('~@/assets/fonts/Shabnam-Light-FD.eot');
        src: url('~@/assets/fonts/Shabnam-Light-FD.eot?#iefix') format('embedded-opentype'),
        url('~@/assets/fonts/Shabnam-Light-FD.woff2') format('woff2'),
        url('~@/assets/fonts/Shabnam-Light-FD.woff') format('woff'),
        url('~@/assets/fonts/Shabnam-Light-FD.ttf') format('truetype');
        font-weight: 300;
    }

    @font-face {
        font-family: Shabnam;
        src: url('~@/assets/fonts/Shabnam-Medium-FD.eot');
        src: url('~@/assets/fonts/Shabnam-Medium-FD.eot?#iefix') format('embedded-opentype'),
        url('~@/assets/fonts/Shabnam-Medium-FD.woff2') format('woff2'),
        url('~@/assets/fonts/Shabnam-Medium-FD.woff') format('woff'),
        url('~@/assets/fonts/Shabnam-Medium-FD.ttf') format('truetype');
        font-weight: 500;
    }

    * {
        letter-spacing: 0 !important;
    }

    .dir, .dir .v-application, .dir .v-dialog {
        font-family: Roboto, sans-serif;
        text-align: left;
        direction: ltr;
    }

    .dir .v-input__prepend-inner {
        margin-right: 5px;
    }

    .dirFa .v-input__prepend-inner {
        margin-left: 5px;
    }

    .dirFa, .dirFa .v-application, .dirFa .v-dialog {
        font-family: Shabnam;
        text-align: right;
        direction: rtl;
    }

    .dir .v-label {
        right: auto !important;
        left: 0 !important;
    }

    .dirFa .v-label {
        right: 0 !important;
        left: auto !important;
    }

    .dirFa .v-label--active {
        transform: translateY(-25px) translateX(12%) scale(.75) !important;
    }

    .dir .v-slide-group__content {
        flex-direction: row-reverse;
    }

    .dir .v-label--active {
        transform: translateY(-25px) translateX(-12%) scale(.75) !important;
    }

    .dirFa .v-messages__message {
        float: right;
    }

    .dir .v-messages__message {
        float: left;
    }

    .v-application--wrap {
        background-color: #f9f9fb !important;
        height: 100vh;
        min-height: unset !important;
    }

    *:focus {
        box-shadow: none !important;
        border: none !important;
        outline: none !important;
    }

    button:focus,
    input:focus,
    textarea:focus {
        box-shadow: none !important;
        border: none !important;
        outline: none !important;
    }

    a:hover {
        text-decoration: none !important;
    }

    ul,
    ol {
        margin: 0 !important;
        padding: 0;
        list-style: none;
    }

    .noSpace {
        margin: 0 !important;
        padding: 0 !important;
    }

    a {
        text-decoration: none;
    }

    .v-overlay__scrim {
        z-index: 2;
    }

    .v-btn__content {
        text-align: center;
        align-self: center;
    }

    .fade-enter {
        opacity: 0;
    }

    .fade-enter-active {
        transition: opacity 1s ease;
    }

    .fade-leave {

    }

    .fade-leave-active {
        transition: opacity 1s ease;
        opacity: 0;
    }

    .center_cropped {
        background-position: center center;
        background-repeat: no-repeat;
        object-position: center;
        background-size: cover;
        object-fit: cover;
        border-radius: 50%;
    }

    .bg-gradient {
        background-image: linear-gradient(#ffffff, #ffffff) !important;
    }

    .html-content img {
        max-width: 100% !important;
        height: auto !important;
    }

    .v-list-item__title {
        font-size: 13px !important;
    }

    .html-content ul li {
        display: list-item !important;
        list-style-type: disc;
        margin-right: 20px;
        margin-left: 20px;
    }

    .html-content li::marker {
        /*content: initial !important;*/
    }

    .v-stepper__step__step {
        margin: 0 10px auto;
        background-color: #427BD5;
    }

    .v-input--selection-controls__input {
        margin-left: 10px;
    }

    .v-stepper__content {
        padding: 0;
        margin-top: 10px;
    }

    .v-stepper {
        padding: 20px;
    }

    .v-label {
        font-weight: normal;
        font-size: 12px !important;
    }

    .v-tabs {
        direction: rtl !important;
    }

    .v-tab {
        font-size: 13px !important;
    }

    .v-tab::before, .v-tabs-slider {
        background-color: #42C7D5 !important;
    }

    label {
        margin-bottom: 0 !important;
    }

    .multi-line {
        white-space: pre-line;
    }

    .v-dialog {
        box-shadow: none !important;
    }

    .ltr-fa {
        direction: rtl;
        text-align: right;
    }

    .v-text-field__slot textarea {
        height: 32px;
    }

    .tag-item {
        margin-right: 10px;
        background-color: #00aff0;
        color: white !important;
        font-size: 13px;
        padding: 4px 20px;
        border-radius: 50px;
        font-weight: bold;
        margin-bottom: 5px;
    }

    .tag-item-fa {
        margin-left: 10px;
        background-color: #00aff0;
        color: white !important;
        font-size: 13px;
        padding: 4px 20px;
        border-radius: 50px;
        font-weight: bold;
        margin-bottom: 5px;
    }

    .btn {
        padding-top: 5px !important;
        padding-bottom: 5px !important;
    }

    .v-tab--active {
        color: #00aff0 !important;
    }

    .review-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    .center-cropped {
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        object-position: center center;
        object-fit: cover;
        overflow: hidden
    }

    .swal2-container {
        z-index: 1000000;
    }
</style>
